<template>
  <div>
    <div class="row mb-4">
      <div class="col-12 subtitle">
        Usarás un proyector o pizarra inteligente en la sala de clases
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <button class="button secondary" @click="showModal.WorkGroup = true">
          Crear Trabajo Grupal
        </button>
        <button class="button primary mx-3">Historial</button>
      </div>
    </div>

    <div class="row">
      <WorkGroupModal
        v-if="showModal.WorkGroup"
        @close="showModal.WorkGroup = false"
      />
    </div>
  </div>
</template>

<script>
import WorkGroupModal from "@/components/workSession/WorkGroupModal";

export default {
  name: "GroupWorking",
  components: {
    WorkGroupModal,
  },
  data() {
    return {
      showModal: {
        WorkGroup: false,
      },
    };
  },
};
</script>
